import { render, staticRenderFns } from "./RecordCell.vue?vue&type=template&id=3304cb7a&scoped=true"
import script from "./RecordCell.vue?vue&type=script&lang=js"
export * from "./RecordCell.vue?vue&type=script&lang=js"
import style0 from "./RecordCell.vue?vue&type=style&index=0&id=3304cb7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3304cb7a",
  null
  
)

export default component.exports